<template>
  <div>
    <Loading v-if="loadingTable" style="margin-top: 180px" />

    <div v-else>
      <div class="d-flex" style="position: absolute; z-index: 3">
        <agregar-planificacion-anual-modal :semanas="semanasDelAnio" />
        <filtro-planificacion-anual />
        <reporte-planificacion-anual-modal />
        <Button
          :size="15"
          color="#1d6f42"
          colorText="#ffffff"
          title="Agregar planificación anual"
          icon="fas fa-file-excel"
          :width="30"
          round
          traslate
          class="m-1"
          @click.native="descargarExcel"
        />
      </div>

      <DataTable
        v-if="acciones.length"
        :headers="Headers"
        :data="data"
        :acciones="acciones"
        :max="10"
        paginacion
        buscar
        idtabla="depositos"
        :seleccionar="obtenerFilaSeleccionada"
      />
    </div>

    <!-- Modal editar -->
    <editar-planificacion-anual-modal
      :dataAux="dataAuxActualizar"
      :semanas="semanasDelAnio"
      :index="index_selected"
    />
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapActions, mapState } from "vuex";

// Modals
import FiltroPlanificacionAnual from "../../components/filtros/charter/FiltroPlanificacionAnual.vue";
import AgregarPlanificacionAnualModal from "../../components/modals/charter/planificacionAnual/AgregarPlanificacionAnualModal.vue";
import EditarPlanificacionAnualModal from "../../components/modals/charter/planificacionAnual/EditarPlanificacionAnualModal.vue";

// Componentes
import Button from "../../components/common/Button.vue";
import DataTable from "../../components/common/DataTable.vue";
import Loading from "../../components/common/loading.vue";

// Toast
import VueToastify from "vue-toastify";
Vue.use(VueToastify);

// Constantes
import { getPlanificacionAnualCharter, eliminarPlanificacionAnualCharter } from "../../constants/charter";
import ReportePlanificacionAnualModal from '../../components/modals/charter/planificacionAnual/ReportePlanificacionAnualModal.vue';

export default {

  data() {
    return {
      Headers: ["Año", "Empresa", "Pallet", "Total anual", "Fecha creación","Fecha modificación", "Acciones"],
      dataAux: [],
      acciones: [],
      data: [],
      semanasDelAnio: "",
      dataAuxActualizar: {},
      index_selected: ""
    };
  },

  components: {
    AgregarPlanificacionAnualModal,
    FiltroPlanificacionAnual,
    Button,
    DataTable,
    Loading,
    EditarPlanificacionAnualModal,
    ReportePlanificacionAnualModal,
  },
  
  computed: {
    ...mapState("charter", ["dataDataTablePlanificacionAnualFiltrada","dataDataTablePlanificacionAnual"]),
    ...mapState(["loadingTable", "visibleModalEditar"]),
  },

  methods: {
    // Acciones de Vuex
    ...mapActions([
      "AccionCambiar",
      "ActionSetClientes",
      "ActionSetListaPallets",
      "ActionSetVisibleModalEditar",
    ]),

    ...mapActions("charter", [
      "actionSetServicios",
      "actionSetListaAnios",
      "actionSetListaPallet",
      "actionSetListaRegiones",
      "actionSetPAShowReportModal"
    ]),

    // Función para actualizar url en state
    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },

    async obtenerPlanificacionAnual() {

      let { data, years_list, pallets_list, routes_list} = await getPlanificacionAnualCharter();

      this.data = data;
      
      // this.actionSetDataDataTablePlanificacionAnual(data);
      this.actionSetListaAnios(years_list);
      this.actionSetListaPallet(pallets_list);
      this.actionSetListaRegiones(routes_list);

    },

    async generarBotonesAcciones() {

      let me = this;

      me.acciones = [];

      if (me.data.length > 0) {

        await me.data.map((item, index) => {
          me.acciones.push([
            {
              icon: "fa fa-edit",
              title: "Editar planificación",
              id: index,
            },
            {
              icon: "fa fa-trash text-danger",
              title: "Eliminar planificación",
              id: index,
            },
          ]);
        });
        
      }

    },

    obtenerFilaSeleccionada(fila) {

      let { id, accion } = fila;
      let dataFila = this.data[id];

      switch (accion) {
        case "Editar planificación":

          this.dataAuxActualizar = dataFila;
          this.index_selected = id;
          this.ActionSetVisibleModalEditar(true);

          break;

        case "Eliminar planificación":
          this.$vToastify.prompt("¿Desea eliminar la planificación?").then(
            (respuesta) => respuesta && this.eliminarPlanificacionAnual( dataFila.data_complementaria.annual_plan_id )
          );

          break;

        default:
          break;
      }
      
    },

    async eliminarPlanificacionAnual(id) {

      this.$vToastify.loader("Eliminando planificación");

      let data = [{
        "plan_id" : id
      }];

      let sql = await eliminarPlanificacionAnualCharter(data);

      if (!sql.error) {

        // Consulta nuevamente a la API para obtener la nueva data
        this.obtenerPlanificacionAnual();

        this.$vToastify.success(
          "Depósito eliminado correctamente",
          "¡Realizado!"
        );

        // Detener Toast info
          this.$vToastify.stopLoader();

      } else {

        this.$vToastify.error("El registro no se pudo eliminar", "Ups!");
        
        // Detener Toast info
        this.$vToastify.stopLoader();

      }

    },

    async descargarExcel(){
      
      this.actionSetPAShowReportModal(true)

    }

  },

  created() {
    // Ejecución de actualizarURL una vez que se carga el componente
    this.actualizarURL();
    this.obtenerPlanificacionAnual();
  },

  watch: {

    data: function (_new) {
      _new && this.generarBotonesAcciones();
    },

    dataDataTablePlanificacionAnualFiltrada: function (_new) {

      let me = this;

      me.dataAuxActualizar = [];

      let { data, years_list, pallets_list } = _new;

      me.data = [];
      me.data = data;
      me.dataAuxActualizar = data[this.index_selected];
      me.actionSetListaAnios(years_list);
      me.actionSetListaPallet(pallets_list);
      
      me.generarBotonesAcciones(); 

    },

    dataDataTablePlanificacionAnual : function(_new){

      if(_new){

        this.dataAuxActualizar = [];
        this.data = [];

        if ( Object.keys(_new).length >= 10) {

          this.data = _new.data;
          this.dataAuxActualizar = _new.data[this.index_selected];

        } else {

          this.data = _new;
          this.dataAuxActualizar = _new[this.index_selected];
          
        }

        this.generarBotonesAcciones();


      } 

    }
    
  },

};
</script>

<style></style>
